import { render, staticRenderFns } from "./call-disposition-tool.vue?vue&type=template&id=140f5842"
import script from "./call-disposition-tool.vue?vue&type=script&lang=js"
export * from "./call-disposition-tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports